<template>
  <div class="dashboard-container">

    

    <!-- Visites aujourd'hui avec les métriques -->
    <div class="main-card visits-card">
      <div class="visits-header">
        <div class="circle-icon">
          <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="white" stroke-width="2">
            <path d="M22 12h-4l-3 9L9 3l-3 9H2"></path>
          </svg>
        </div>
        <div class="visits-info">
          <div class="time-label-accent">Chatbots actifs</div>
          <div class="time-value">
            <span class="hours">{{ stats.chatbotActive || 0 }}</span>
            <span class="trend">sur {{ stats.chatbotCount || 0 }}</span>
          </div>
        </div>
      </div>
      
      <div class="metrics-mini-grid">
        <div class="mini-metric">
          <div class="metric-icon users">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="white" stroke-width="2">
              <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>
              <circle cx="9" cy="7" r="4"></circle>
              <path d="M23 21v-2a4 4 0 0 0-3-3.87"></path>
              <path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
            </svg>
          </div>
          <div class="metric-info">
            <span class="metric-value">{{ formatNumber(stats.userCount || 0) }}</span>
            <span class="metric-label">Utilisateurs actifs</span>
          </div>
        </div>

        <div class="mini-metric">
          <div class="metric-icon messages">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="white" stroke-width="2">
              <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"></path>
            </svg>
          </div>
          <div class="metric-info">
            <span class="metric-value">{{ formatNumber(stats.discussionCount || 0) }}</span>
            <span class="metric-label">Discussions</span>
          </div>
        </div>

        <div class="mini-metric">
          <div class="metric-icon bots">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="white" stroke-width="2">
              <rect x="3" y="11" width="18" height="10" rx="2"/>
              <circle cx="12" cy="5" r="2"/>
              <path d="M12 7v4"/>
              <line x1="8" y1="16" x2="8.01" y2="16"/>
              <line x1="16" y1="16" x2="16.01" y2="16"/>
            </svg>
          </div>
          <div class="metric-info">
            <span class="metric-value">{{ formatNumber(stats.chatbotCount || 0) }}</span>
            <span class="metric-label">Chatbots total</span>
          </div>
        </div>
      </div>
    </div>

    <!-- Carte du taux de popularité -->
   
    <!-- Carte du taux de popularité -->
    
    <!-- Carte du taux de popularité - Nouveau design -->
    

     

    <!-- Nouveau design amélioré Performance Chatbots -->
    <div class="performance-card">
      <div class="performance-header">
        <div class="performance-title-container">
          <div class="performance-icon-wrapper">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <path d="M21 15c0 1.1-.9 2-2 2H7l-4 4V5c0-1.1.9-2 2-2h14c1.1 0 2 .9 2 2v10z"/>
              <path d="M15 10l-4 4-4-4"/>
            </svg>
          </div>
          <div>
            <h2 class="performance-title">Performance Chatbots</h2>
            <p class="performance-description">Analyse comparative des conversations par chatbot</p>
          </div>
        </div>
         
      </div>

      <div class="performance-stats-container" v-if="stats.fourMostPopularChatbot && stats.fourMostPopularChatbot.length > 0">
        <div class="growth-stat">
          <div class="growth-value">+{{ getGrowthPercentage() }}%</div>
          <div class="growth-label">
            <span class="highlight-text">{{ stats.fourMostPopularChatbot[0].bot_name }}</span> dépasse la moyenne des autres chatbots
          </div>
        </div>

        <div class="performance-chart-container">
          <div class="highlighted-value">
            <span>{{ formatNumber(stats.fourMostPopularChatbot[0].total_discussions) }}</span>
            <div class="value-label">discussions</div>
          </div>
          
          <div class="performance-chart">
            <div 
              v-for="(chatbot, index) in stats.fourMostPopularChatbot" 
              :key="index"
              class="chart-column"
              @mouseenter="showChatbotTooltip($event, chatbot, index)"
              @mouseleave="hideChatbotTooltip()"
            >
              <div class="chart-dot" :class="{ 'primary': index === 0, 'secondary': index !== 0 }"></div>
              <div class="chart-line" :style="{ height: `${getBarHeight(chatbot.total_discussions)}px` }"></div>
              <div class="chart-label" :class="{ 'active': index === 0 }">
                {{ getInitials(chatbot.bot_name) }}
              </div>
            </div>
          </div>
          
          <div class="chatbot-tooltip" ref="chatbotTooltip" :style="tooltipStyle">
            <div class="tooltip-header">{{ activeTooltip.name }}</div>
            <div class="tooltip-stats">
              <div class="tooltip-stat">
                <span class="stat-icon">👥</span>
                <span class="stat-value">{{ formatNumber(activeTooltip.users) }}</span>
                <span class="stat-label">utilisateurs</span>
              </div>
              <div class="tooltip-stat">
                <span class="stat-icon">💬</span>
                <span class="stat-value">{{ formatNumber(activeTooltip.discussions) }}</span>
                <span class="stat-label">discussions</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="performance-footer">
        <button class="view-details-button">
          <span>Voir les détails complets</span>
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <path d="M5 12h14M12 5l7 7-7 7"></path>
          </svg>
        </button>
      </div>
    </div>

    <!-- Carte de réunions/calendrier -->
    
    <div class="users-card">
      <div class="card-header">
        <h2>Dernières discussions</h2>
        <div class="user-count">{{ formatNumber(stats.discussionCount || 0) }}</div>
      </div>
      
      <div class="users-list">
        <div v-for="(discussion, index) in stats.fourLastDiscussions" :key="index" @click="openConversation(discussion)" class="user-item">
          <img :src="getAvatarUrl(discussion.user_full_name)" :alt="discussion.user_full_name" class="user-avatar" />
          <div class="user-info">
            <div class="user-name">{{ discussion.user_full_name }}</div>
            <div class="user-status">
              <span class="chatbot-name">{{ discussion.bot_name }}</span> • {{ getTimeSinceUpdate(discussion.update_date) }}
            </div>
          </div>
          <div class="user-rating">{{ formatNumber(discussion.number_of_discussions) }}</div>
        </div>
      </div>

      <button class="fullwidth-button" @click="navigateToAllUsers">
        <span class="button-icon">👥</span>
        <span class="button-text">Voir toutes les discussions</span>
        <span class="button-arrow">→</span>
      </button>
    </div>

    <!-- Carte d'analyse des messages -->
    <div class="messages-card">
      <div class="card-header">
        <h2>Messages mensuels</h2>
        <div class="messages-total">
          <span>{{ formatNumber(stats.monthlyMessages || 0) }}</span>
        </div>
      </div>
      
      <div class="bar-chart">
        <div v-for="(month, index) in ['Jan', 'Fév', 'Mar', 'Avr', 'Mai', 'Juin']" 
             :key="index" 
             class="bar-column">
          <div class="bar" :style="{ height: getRandomBarHeight(index) + '%' }"></div>
          <div class="bar-label">{{ month }}</div>
        </div>
      </div>
    </div>

    <!-- Carte de temps de projet -->
    
   
    <!-- Carte des utilisateurs -->
     

    <!-- Métriques principales -->
   
  </div>
</template>

<script>
import { apiBaseUrl } from '@/config';

export default {
  name: 'DashboardStats',
  data() {
    return {
      stats: {
        chatbotCount: 0,
        chatbotActive: 0,
        userCount: 0,
        discussionCount: 0,
        progressPercentage: 34,
        upcomingCalls: 3,
        visitesToday: 0,
        popularity: 93,
        rating: "4.7",
        popularityRate: 87,
        popularityChange: 2,
        monthlyMessages: 0,
        projectHours: 645,
        fourMostPopularChatbot: [],
        fourLastDiscussions: []
      },
      selectedProject: 'PeeloChat Dashboard',
      activeUsers: [ ],
      barHeights: [],
      tooltipStyle: {
        display: 'none',
        top: '0px',
        left: '0px'
      },
      activeTooltip: {
        name: '',
        users: 0,
        discussions: 0
      }
    }
  },
  mounted() {
    this.fetchStats();
    // Générer des hauteurs aléatoires pour le graphique à barres
    for (let i = 0; i < 6; i++) {
      this.barHeights.push(Math.floor(Math.random() * 60) + 40);
    }
  },
  methods: {
    async openConversation(user){
       this.$router.push(`/dashboard/chat/${user.idbot}/${user.user_phone_number}`);
    },
    async fetchStats() {
      try {
        // Récupérer le token depuis localStorage
        const userData = localStorage.getItem('user');
        if (!userData) {
          console.error('Données utilisateur non trouvées');
          return;
        }
        
        const userObj = JSON.parse(userData);
        const token = userObj.data.token;
        
        if (!token) {
          console.error('Token non trouvé dans les données utilisateur');
          return;
        }
        
        // Utiliser apiBaseUrl et inclure le token d'authentification
        const response = await fetch(`${apiBaseUrl}/get/stats`, {
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
          }
        });
        
        const data = await response.json();
        if (data.message === "Statistiques récupérées avec succès.") {
          this.stats = {
            ...this.stats,
            ...data.stats,
            monthlyMessages: data.stats.discussionCount // Utiliser le nombre total de discussions comme messages mensuels
          };
        }
      } catch (error) {
        console.error('Erreur lors de la récupération des statistiques:', error);
      }
    },
    formatNumber(number) {
      if (!number) return "0";
      return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
    },
    getCurrentMonth() {
      const months = ['Janvier', 'Février', 'Mars', 'Avril', 'Mai', 'Juin', 'Juillet', 'Août', 'Septembre', 'Octobre', 'Novembre', 'Décembre'];
      return months[new Date().getMonth()];
    },
    getCurrentDay() {
      const days = ['Dim', 'Lun', 'Mar', 'Mer', 'Jeu', 'Ven', 'Sam'];
      return days[new Date().getDay()] + ', ' + new Date().getDate();
    },
    getCurrentDayIndex() {
      return new Date().getDay() - 1 < 0 ? 6 : new Date().getDay() - 1;
    },
    getDaysOfWeek() {
      const days = [];
      const dayNames = ['Lun', 'Mar', 'Mer', 'Jeu', 'Ven', 'Sam', 'Dim'];
      const today = new Date();
      const dayOfWeek = today.getDay(); // 0 = dimanche, 1 = lundi...
      const date = today.getDate();
      
      // Ajuster pour commencer par lundi
      const startDay = dayOfWeek === 0 ? 6 : dayOfWeek - 1;
      
      for (let i = 0; i < 7; i++) {
        const dayIndex = (i + 1) % 7; // 0 = lundi, 1 = mardi...
        const dayDiff = dayIndex - startDay;
        const dayDate = new Date(today);
        dayDate.setDate(date + dayDiff);
        
        days.push({
          name: dayNames[dayIndex],
          number: dayDate.getDate()
        });
      }
      
      return days.slice(0, 6); // Prendre seulement 6 jours pour l'affichage
    },
    getRandomBarHeight(index) {
      if (this.barHeights.length <= index) {
        return Math.floor(Math.random() * 60) + 40;
      }
      return this.barHeights[index];
    },
    getAvatarUrl(name) {
      // Utiliser le même format d'URL que les avatars statiques
      if (!name) return `https://ui-avatars.com/api/?name=User&background=random`;
      return `https://ui-avatars.com/api/?name=${encodeURIComponent(name)}&background=random&color=fff`;
    
      //return `https://api.dicebear.com/7.x/avataaars/svg?seed=${encodeURIComponent(name)}`;
    },
    getTimeSinceUpdate(dateString) {
      const updateDate = new Date(dateString);
      const now = new Date();
      
      // Calcul de la différence en millisecondes
      const diffMs = now - updateDate;
      
      // Convertir en différentes unités
      const diffSecs = Math.floor(diffMs / 1000);
      const diffMins = Math.floor(diffSecs / 60);
      const diffHours = Math.floor(diffMins / 60);
      const diffDays = Math.floor(diffHours / 24);
      
      // Retourner la différence dans l'unité la plus appropriée
      if (diffMins < 1) return 'maintenant';
      if (diffMins < 60) return `${diffMins} min`;
      if (diffHours < 24) return `${diffHours}h`;
      return `${diffDays}j`;
    },
    getRankColor(index) {
      const colors = ['#FFD700', '#C0C0C0', '#CD7F32', '#128C7E'];
      return index < colors.length ? colors[index] : colors[3];
    },
    getPercentage(value) {
      if (!this.stats.fourMostPopularChatbot || this.stats.fourMostPopularChatbot.length === 0) {
        return 0;
      }
      const maxValue = Math.max(...this.stats.fourMostPopularChatbot.map(c => c.total_discussions));
      return (value / maxValue) * 100;
    },
    getMostPopularValue() {
      if (!this.stats.fourMostPopularChatbot || this.stats.fourMostPopularChatbot.length === 0) {
        return "0";
      }
      const mostPopular = this.stats.fourMostPopularChatbot[0];
      return this.formatNumber(mostPopular.total_discussions);
    },
    getMostPopularName() {
      if (!this.stats.fourMostPopularChatbot || this.stats.fourMostPopularChatbot.length === 0) {
        return "Aucun";
      }
      return this.stats.fourMostPopularChatbot[0].bot_name;
    },
    calculateRotation() {
      if (!this.stats.fourMostPopularChatbot || this.stats.fourMostPopularChatbot.length === 0) {
        return 0;
      }
      // Calculer un pourcentage entre 0 et 180 degrés
      const totalDiscussions = this.stats.discussionCount || 1;
      const mostPopularDiscussions = this.stats.fourMostPopularChatbot[0].total_discussions;
      const percentage = (mostPopularDiscussions / totalDiscussions) * 100;
      // Limiter à 180 degrés maximum (demi-cercle)
      return Math.min(percentage * 1.8, 180);
    },
    calculatePercentage() {
      if (!this.stats.fourMostPopularChatbot || this.stats.fourMostPopularChatbot.length === 0) {
        return 0;
      }
      const totalDiscussions = this.stats.discussionCount || 1;
      const mostPopularDiscussions = this.stats.fourMostPopularChatbot[0].total_discussions;
      const percentage = (mostPopularDiscussions / totalDiscussions) * 100;
      return Math.round(percentage);
    },
    getMaxDiscussions() {
      if (!this.stats.fourMostPopularChatbot || this.stats.fourMostPopularChatbot.length === 0) {
        return 1;
      }
      return Math.max(...this.stats.fourMostPopularChatbot.map(chatbot => chatbot.total_discussions));
    },
    getGrowthPercentage() {
      if (!this.stats.fourMostPopularChatbot || this.stats.fourMostPopularChatbot.length <= 1) {
        return 0;
      }
      
      // Calcul de la moyenne des discussions pour tous les chatbots sauf le premier
      const otherBots = this.stats.fourMostPopularChatbot.slice(1);
      const averageOthers = otherBots.reduce((sum, bot) => sum + bot.total_discussions, 0) / otherBots.length;
      
      // Calcul du pourcentage de croissance du plus populaire par rapport à la moyenne des autres
      const mostPopularDiscussions = this.stats.fourMostPopularChatbot[0].total_discussions;
      const growthPercentage = ((mostPopularDiscussions - averageOthers) / averageOthers) * 100;
      
      return Math.round(growthPercentage);
    },
    getBarHeight(discussions) {
      if (!this.stats.fourMostPopularChatbot || this.stats.fourMostPopularChatbot.length === 0) {
        return 0;
      }
      const maxDiscussions = Math.max(...this.stats.fourMostPopularChatbot.map(c => c.total_discussions));
      // Calculer la hauteur entre 40px minimum et 180px maximum
      const minHeight = 40;
      const maxHeight = 180;
      const percentage = discussions / maxDiscussions;
      return Math.round(minHeight + (maxHeight - minHeight) * percentage);
    },
    getInitials(name) {
      if (!name) return '';
      // Pour les noms composés, prendre la première lettre de chaque mot (max 2 lettres)
      const words = name.split(' ');
      if (words.length > 1) {
        return (words[0].charAt(0) + words[1].charAt(0)).toUpperCase();
      }
      // Sinon prendre simplement la première lettre
      return name.charAt(0).toUpperCase();
    },
    showChatbotTooltip(event, chatbot, index) {
      // Mettre à jour les données du tooltip
      this.activeTooltip = {
        name: chatbot.bot_name,
        users: chatbot.total_users,
        discussions: chatbot.total_discussions
      };
      
      // Calculer la position du tooltip
      const rect = event.target.getBoundingClientRect();
      const tooltipWidth = 220; // Largeur estimée du tooltip
      
      this.tooltipStyle = {
        display: 'block',
        top: `${rect.top - 120}px`, // Positionner au-dessus de la colonne
        left: `${rect.left - (tooltipWidth / 2) + 20}px`, // Centrer le tooltip
        zIndex: 1000
      };
    },
    hideChatbotTooltip() {
      this.tooltipStyle.display = 'none';
    },
    navigateToAllUsers() {
      this.$router.push('/dashboard/all-users');
    }
  }
}
</script>

<style scoped>
.dashboard-container {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-gap: 20px;
  padding: 20px;
  background-color: #f5f5f5; /* Changé de #ECE5DD à un gris clair */
  border-radius: 12px;
}

/* Styles pour les textes */
.time-label-accent, .metric-label, .metric-value, .user-name, .user-status, 
.card-header h2, .popularity-message, .hours, .trend, .score-number, .bar-label,
.month-selector, .call-info, .day-item, .messages-total {
  cursor: pointer;
}

/* Carte principale - Statistiques */
.main-card {
  grid-column: span 1;
  background: linear-gradient(135deg, #075E54 0%, #128C7E 100%); /* Même dégradé que la carte "Temps total projet" */
  border-radius: 20px;
  padding: 28px;
  color: white;
  display: flex;
  flex-direction: column;
  gap: 20px;
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.15);
  position: relative;
  overflow: hidden;
}

.main-card::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: radial-gradient(circle at top right, rgba(255,255,255,0.2), transparent 60%);
  z-index: 0;
}

.stats-header {
  margin-bottom: 1.5rem;
  position: relative;
  z-index: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
}

.stats-title {
  font-size: 1.2rem;
  opacity: 1;
  color: white;
  font-weight: 500;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.2);
  letter-spacing: 0.5px;
  text-transform: uppercase;
  position: relative;
}

.stats-title::after {
  content: '';
  position: absolute;
  bottom: -8px;
  left: 50%;
  transform: translateX(-50%);
  width: 40px;
  height: 3px;
  background: rgba(255, 255, 255, 0.4);
  border-radius: 2px;
}

.stats-number {
  font-size: 4rem;
  font-weight: 800;
  line-height: 1;
  margin-top: 1rem;
  color: white;
  text-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
  letter-spacing: -1px;
  display: inline-block;
  position: relative;
}

.stats-number::before {
  content: '';
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 120px;
  height: 120px;
  background: radial-gradient(circle, rgba(255, 255, 255, 0.2) 0%, rgba(255, 255, 255, 0) 70%);
  border-radius: 50%;
  z-index: -1;
}

.stats-metrics {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 0.75rem;
  position: relative;
  z-index: 1;
  margin-top: 0.5rem;
}

.metric {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  background: rgba(255, 255, 255, 0.15);
  padding: 0.75rem;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  text-align: center;
  transition: transform 0.2s ease, background 0.2s ease;
  position: relative;
  overflow: hidden;
}

.metric:hover {
  transform: translateY(-3px);
  background: rgba(255, 255, 255, 0.2);
}

.metric::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(45deg, rgba(255, 255, 255, 0.1), transparent);
  z-index: -1;
}

.metric-icon {
  width: 40px;
  height: 40px;
  background: rgba(255, 255, 255, 0.3);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 0.25rem;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.metric-value {
  font-size: 1.6rem;
  font-weight: 800; /* Encore plus gras */
  color: white;
  text-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);
  letter-spacing: 0.5px;
  line-height: 1;
  margin: 0.25rem 0;
}

.metric-label {
  font-size: 0.75rem;
  color: rgba(255, 255, 255, 0.9);
  font-weight: 400;
  opacity: 1;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

/* Carte de popularité */
.popularity-card {
  grid-column: span 1;
  background: #f0f0f0; /* Changé de white à gris très clair */
  border-radius: 20px;
  padding: 24px;
  display: flex;
  flex-direction: column;
  gap: 20px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
  min-height: 420px; /* Hauteur minimale pour garantir l'alignement */
}

.card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 0.5rem;
}

.card-header h2 {
  margin: 0;
  font-size: 1.25rem;
  font-weight: 600;
  color: #075E54; /* Couleur texte WhatsApp */
}

.popularity-score {
  display: flex;
  align-items: baseline;
  gap: 0.5rem;
}

.score-number {
  font-size: 2rem;
  font-weight: 700;
  color: #128C7E; /* Couleur primaire WhatsApp */
}

.score-change {
  font-size: 0.875rem;
  font-weight: 500;
  color: #25D366; /* Vert WhatsApp */
  background: rgba(37, 211, 102, 0.1);
  padding: 2px 6px;
  border-radius: 4px;
}

.popularity-gauge {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 150px;
}

.gauge-circle {
  width: 120px;
  height: 120px;
  border-radius: 50%;
  background: #f3f3f3;
  position: relative;
  overflow: hidden;
}

.gauge-progress {
  position: absolute;
  width: 100%;
  height: 100%;
  clip-path: polygon(50% 50%, 100% 50%, 100% 0, 0 0, 0 50%);
  background: linear-gradient(90deg, #25D366, #128C7E);
  transform-origin: bottom center;
}

.gauge-center {
  position: absolute;
  width: 80px;
  height: 80px;
  background: #f0f0f0; /* Changé de white à gris très clair */
  border-radius: 50%;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.popularity-message {
  text-align: center;
  color: #075E54;
  font-size: 0.875rem;
  margin: 0.5rem 0;
}

.highlight {
  color: #25D366;
  font-weight: 600;
}

.insight-button {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: #128C7E;
  color: white;
  border: none;
  border-radius: 12px;
  padding: 12px 16px;
  font-size: 0.875rem;
  font-weight: 500;
  cursor: pointer;
  margin-top: auto;
  width: 100%;
  transition: all 0.2s;
}

.insight-button:hover {
  background: #075E54;
}

/* Carte de calendrier */
.calendar-card {
  grid-column: span 1;
  background: #f0f0f0; /* Changé de white à gris très clair */
  border-radius: 20px;
  padding: 24px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
}

.month-selector {
  display: flex;
  align-items: center;
  gap: 8px;
  background-color: rgba(18, 140, 126, 0.1);
  border-radius: 20px;
  padding: 6px 12px;
  cursor: pointer;
  font-size: 0.875rem;
  color: #075E54;
}

.call-info {
  display: flex;
  align-items: center;
  gap: 8px;
  color: #128C7E;
  font-size: 0.875rem;
}

.days-row {
  display: flex;
  justify-content: space-between;
  margin-top: 16px;
}

.day-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  border-radius: 50%;
  padding: 4px;
}

.day-item.active {
  background-color: #25D366;
  color: white;
}

.day-number {
  font-weight: 600;
  font-size: 0.875rem;
}

.day-name {
  font-size: 0.75rem;
  color: #777;
}

.day-item.active .day-name {
  color: rgba(255, 255, 255, 0.8);
}

/* Carte des messages */
.messages-card {
  grid-column: span 1;
  background: #f0f0f0; /* Changé de white à gris très clair */
  border-radius: 20px;
  padding: 24px;
  display: flex;
  flex-direction: column;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
}

.messages-total {
  font-size: 1.25rem;
  font-weight: 600;
  color: #128C7E;
}

.bar-chart {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  height: 150px;
  margin-top: 1rem;
}

.bar-column {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
}

.bar {
  width: 10px;
  background: linear-gradient(to top, #128C7E, #25D366);
  border-radius: 5px;
  margin-bottom: 8px;
  transition: height 0.5s;
}

.bar-label {
  font-size: 0.75rem;
  color: #777;
}

/* Carte de temps */
.time-card {
  grid-column: span 1;
  background: linear-gradient(135deg, #075E54 0%, #128C7E 100%);
  border-radius: 20px;
  padding: 24px;
  display: flex;
  align-items: center;
  gap: 16px;
  color: white;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.time-icon {
  background-color: rgba(255, 255, 255, 0.25);
  width: 56px;
  height: 56px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 0 15px rgba(255, 255, 255, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.3);
}

.circle-icon {
  background-color: rgba(255, 255, 255, 0.2);
  width: 60px;
  height: 60px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 0 20px rgba(255, 255, 255, 0.15);
  border: 2px solid rgba(255, 255, 255, 0.5);
  transition: all 0.3s ease;
}

.circle-icon:hover {
  transform: scale(1.05);
  background-color: rgba(255, 255, 255, 0.25);
}

.time-info {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.time-label-accent {
  font-size: 1rem;
  font-weight: 600;
  color: #ffffff;
  text-transform: uppercase;
  letter-spacing: 0.7px;
  text-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);
}

.time-value {
  display: flex;
  align-items: baseline;
  gap: 8px;
}

.hours {
  font-size: 2rem;
  font-weight: 700;
}

.unit {
  font-size: 1.25rem;
  opacity: 0.8;
}

/* Carte des utilisateurs */
.users-card {
  grid-column: span 1;
  background: #f0f0f0; /* Changé de white à gris très clair */
  border-radius: 20px;
  padding: 24px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
  display: flex;
  flex-direction: column;
  min-height: 420px; /* Même hauteur que popularity-card */
}

.user-count {
  font-size: 1.25rem;
  font-weight: 600;
  color: #128C7E;
}

.users-list {
  margin-top: 1rem;
  margin-bottom: 1rem;
  display: flex;
  flex-direction: column;
  gap: 12px;
  flex: 1;
  overflow-y: auto;
  max-height: 250px;
}

.user-item {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 8px;
  border-radius: 12px;
  transition: background 0.2s;
  cursor: pointer;
}

.user-item:hover {
  background: rgba(18, 140, 126, 0.05);
}

.user-avatar {
  width: 40px;
  height: 40px;
  border-radius: 12px;
  overflow: hidden;
  position: relative;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.user-info {
  flex: 1;
}

.user-name {
  font-size: 0.875rem;
  font-weight: 500;
  color: #333;
}

.user-status {
  font-size: 0.75rem;
  color: #777;
}

.user-status.online {
  color: #25D366;
}

.user-rating {
  font-size: 0.875rem;
  font-weight: 600;
  color: #128C7E;
  padding: 3px 6px;
  background: rgba(18, 140, 126, 0.1);
  border-radius: 4px;
}

.chatbot-name {
  font-weight: 600;
  color: #128C7E;
  padding: 1px 4px;
  background: rgba(18, 140, 126, 0.1);
  border-radius: 3px;
  font-size: 0.65rem;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin-top: 4px;
  display: inline-block;
  cursor: pointer;
}

/* Métriques principales */
.metrics-grid {
  grid-column: span 3;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 20px;
}

.metric-card {
  background: #f0f0f0; /* Changé de white à gris très clair */
  border-radius: 20px;
  padding: 20px;
  display: flex;
  align-items: center;
  gap: 16px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
}

.metric-icon {
  width: 48px;
  height: 48px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.metric-icon.users {
  background-color: rgba(37, 211, 102, 0.1);
  color: #25D366;
}

.metric-icon.messages {
  background-color: rgba(18, 140, 126, 0.1);
  color: #128C7E;
}

.metric-icon.bots {
  background-color: rgba(7, 94, 84, 0.1);
  color: #075E54;
}

.metric-info {
  display: flex;
  flex-direction: column;
}

.metric-value {
  font-size: 1.5rem;
  font-weight: 600;
  color: #333;
}

.metric-label {
  font-size: 0.875rem;
  color: #777;
}

/* Responsive */
@media (max-width: 1200px) {
  .dashboard-container {
    grid-template-columns: 1fr 1fr;
  }
  
  .main-card, .popularity-card, .calendar-card, .messages-card, .time-card, .users-card {
    grid-column: span 1;
  }
  
  .metrics-grid {
    grid-column: span 2;
  }
}

@media (max-width: 768px) {
  .dashboard-container {
    grid-template-columns: 1fr;
  }
  
  .main-card, .popularity-card, .calendar-card, .messages-card, .time-card, .users-card, .metrics-grid {
    grid-column: span 1;
  }
  
  .metrics-grid {
    grid-template-columns: 1fr;
  }
}

.main-card.gradient-bg {
  display: none; /* Je cache cette carte qui n'est plus utilisée */
}

.visits-card {
  grid-column: span 3; /* Span sur 3 colonnes au lieu de 1 */
  background: linear-gradient(135deg, #075E54 0%, #128C7E 100%);
  border-radius: 20px;
  padding: 24px;
  display: flex;
  flex-direction: column;
  gap: 24px;
  color: white;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.visits-header {
  display: flex;
  align-items: center;
  gap: 16px;
}

.metrics-mini-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 16px;
  margin-top: 8px;
}

.mini-metric {
  display: flex;
  align-items: center;
  gap: 12px;
  background: rgba(255, 255, 255, 0.15);
  padding: 16px;
  border-radius: 12px;
  transition: transform 0.2s ease;
}

.mini-metric:hover {
  transform: translateY(-3px);
  background: rgba(255, 255, 255, 0.2);
}

.mini-metric .metric-icon {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(255, 255, 255, 0.2);
  color: white;
}

.mini-metric .metric-info {
  display: flex;
  flex-direction: column;
}

.mini-metric .metric-value {
  font-size: 1.4rem;
  font-weight: 700;
  color: white;
}

.mini-metric .metric-label {
  font-size: 0.75rem;
  color: rgba(255, 255, 255, 0.9);
  font-weight: 400;
}

.time-label-accent {
  font-size: 0.9rem;
  opacity: 0.9;
  font-weight: 500;
}

.time-value {
  display: flex;
  align-items: center;
}

.hours {
  font-size: 1.8rem;
  font-weight: 700;
}

.trend {
  font-size: 1rem;
  opacity: 0.9;
  background: rgba(255, 255, 255, 0.2);
  padding: 2px 8px;
  border-radius: 12px;
  margin-left: 8px;
}

.visits-info {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

/* Ajout des styles pour le bouton pleine largeur */
.fullwidth-button {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: #128C7E;
  color: white;
  border: none;
  border-radius: 12px;
  padding: 12px 16px;
  font-size: 0.875rem;
  font-weight: 500;
  cursor: pointer;
  margin-top: auto;
  width: 100%;
  transition: all 0.2s;
}

.fullwidth-button:hover {
  background: #075E54;
}

/* Styles pour la carte des chatbots populaires */
.popular-chatbots {
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin: 16px 0;
}

.popular-chatbot-item {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px;
  background: rgba(240, 240, 240, 0.6);
  border-radius: 10px;
  transition: transform 0.2s, box-shadow 0.2s;
  position: relative;
  overflow: hidden;
  cursor: pointer;
}

.popular-chatbot-item:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.08);
  background: rgba(240, 240, 240, 0.8);
}

.rank {
  width: 28px;
  height: 28px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: var(--rank-color, #128C7E);
  color: white;
  border-radius: 50%;
  font-weight: 700;
  font-size: 0.875rem;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
}

.chatbot-info {
  flex: 1;
}

.chatbot-title {
  font-weight: 600;
  font-size: 0.95rem;
  color: #333;
  margin-bottom: 4px;
  cursor: pointer;
}

.chatbot-stats {
  display: flex;
  gap: 12px;
  font-size: 0.8rem;
  color: #666;
}

.stat {
  display: flex;
  align-items: center;
  gap: 4px;
  cursor: pointer;
}

.popularity-bar {
  position: absolute;
  bottom: 0;
  left: 0;
  height: 3px;
  width: 100%;
  background: rgba(0, 0, 0, 0.05);
}

.popularity-bar .progress {
  height: 100%;
  background: var(--rank-color, #128C7E);
  transition: width 0.8s ease-in-out;
}

/* Responsive ajustements pour les chatbots populaires */
@media (max-width: 768px) {
  .chatbot-stats {
    flex-direction: column;
    gap: 4px;
  }
}

/* Nouveau design pour la carte de balance */
.balance-card {
  grid-column: span 1;
  background: #f0f0f0;
  border-radius: 20px;
  padding: 24px;
  display: flex;
  flex-direction: column;
  gap: 20px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
  min-height: 420px;
}

.balance-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.navigation-arrows {
  display: flex;
  gap: 8px;
}

.nav-arrow {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  border: 1px solid #e0e0e0;
  background: white;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.2s;
}

.nav-arrow:hover {
  background: #f8f8f8;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.05);
}

.gauge-container {
  background: linear-gradient(135deg, #d0ffd0, #b2f5b2);
  border-radius: 16px;
  padding: 24px;
  position: relative;
  overflow: hidden;
  min-height: 240px;
}

.chart-icon {
  position: absolute;
  top: 20px;
  left: 20px;
  width: 44px;
  height: 44px;
  background: white;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
}

.gauge-wrapper {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  margin-top: 30px;
}

.semi-circle-gauge {
  width: 240px;
  height: 120px;
  position: relative;
  margin: 0 auto;
}

.gauge-track {
  width: 240px;
  height: 240px;
  border: 20px solid rgba(255, 255, 255, 0.2);
  border-bottom: 20px solid transparent;
  border-left: 20px solid transparent;
  border-right: 20px solid transparent;
  border-radius: 50%;
  position: absolute;
  box-sizing: border-box;
  top: 0;
  left: 0;
  transform-origin: center center;
  transform: rotate(-180deg);
}

.gauge-progress {
  width: 240px;
  height: 240px;
  border: 20px solid #128C7E;
  border-bottom: 20px solid transparent;
  border-left: 20px solid transparent;
  border-right: 20px solid transparent;
  border-radius: 50%;
  position: absolute;
  box-sizing: border-box;
  top: 0;
  left: 0;
  transform-origin: center center;
  transform: rotate(0deg);
  transition: transform 0.8s ease-in-out;
}

.gauge-indicator {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  transform-origin: center center;
  transform: rotate(0deg);
  transition: transform 0.8s ease-in-out;
}

.indicator-dot {
  position: absolute;
  width: 12px;
  height: 12px;
  background: #4a6bf5;
  border: 3px solid white;
  border-radius: 50%;
  top: 10px;
  left: 50%;
  transform: translateX(-50%);
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);
}

.central-value {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, 0);
  text-align: center;
  width: 100%;
}

.value {
  font-size: 2rem;
  font-weight: 700;
  color: #222;
  line-height: 1;
}

.currency {
  font-size: 0.9rem;
  color: #666;
  margin-top: 5px;
}

.gauge-info {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 20px;
  padding: 0 20px;
}

.percentage {
  display: flex;
  align-items: center;
  gap: 4px;
  font-size: 1.2rem;
  font-weight: 700;
  color: #333;
}

.percentage svg {
  color: #128C7E;
}

.avg-score {
  font-size: 0.9rem;
  color: #555;
}

.avg-score span {
  font-weight: 600;
  color: #128C7E;
}

@media (max-width: 768px) {
  .semi-circle-gauge {
    width: 180px;
    height: 90px;
  }
  
  .gauge-track, .gauge-progress {
    width: 180px;
    height: 180px;
    border-width: 15px;
  }
  
  .value {
    font-size: 1.5rem;
  }
}

/* Styles pour la carte Income Tracker */
.income-tracker-card {
  grid-column: span 1;
  background: white;
  border-radius: 20px;
  padding: 24px;
  display: flex;
  flex-direction: column;
  gap: 24px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
  min-height: 420px;
}

.tracker-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
}

.tracker-title-group {
  display: flex;
  align-items: flex-start;
  gap: 12px;
}

.tracker-icon {
  width: 40px;
  height: 40px;
  background: #f5f5f5;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #333;
}

.tracker-titles {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.tracker-titles h2 {
  margin: 0;
  font-size: 1.4rem;
  font-weight: 600;
  color: #1E293B;
  line-height: 1.2;
}

.tracker-subtitle {
  margin: 0;
  font-size: 0.85rem;
  color: #64748B;
  line-height: 1.4;
  max-width: 300px;
}

.tracker-period-selector {
  display: flex;
  align-items: center;
  gap: 8px;
  background: #F1F5F9;
  border-radius: 999px;
  padding: 8px 16px;
  font-size: 0.85rem;
  color: #334155;
  cursor: pointer;
}

.tracker-content {
  display: flex;
  flex-direction: column;
  gap: 24px;
  flex: 1;
}

.growth-indicator {
  display: flex;
  align-items: flex-start;
  gap: 8px;
}

.growth-percentage {
  font-size: 2.5rem;
  font-weight: 700;
  color: #128C7E;
  line-height: 1;
}

.growth-text {
  font-size: 0.9rem;
  color: #64748B;
  line-height: 1.4;
  align-self: center;
  max-width: 200px;
}

.chatbot-chart {
  display: flex;
  flex-direction: column;
  height: 220px;
  position: relative;
  margin-top: 20px;
}

.current-value {
  position: absolute;
  top: 10px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 5;
}

.value-bubble {
  background: #272F41;
  color: white;
  padding: 8px 16px;
  border-radius: 999px;
  font-weight: 600;
  font-size: 0.9rem;
  white-space: nowrap;
}

.chart-bars {
  display: flex;
  justify-content: space-around;
  align-items: flex-end;
  height: 180px;
  margin-top: auto;
  position: relative;
}

.chart-bar-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 40px;
  position: relative;
}

.chart-point {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background: #6B83C1;
  position: absolute;
  top: 0;
  z-index: 2;
}

.chart-bar {
  width: 2px;
  background: #D9E2F5;
  margin-top: 5px;
  transition: height 0.8s ease-out;
}

.day-marker {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background: #F1F5F9;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 500;
  color: #64748B;
  margin-top: 10px;
  cursor: pointer;
  transition: all 0.2s;
}

.day-marker.active {
  background: #272F41;
  color: white;
}

/* Adaptation des couleurs aux thèmes du dashboard */
.income-tracker-card {
  background: #f0f0f0;
}

.tracker-icon {
  background: rgba(18, 140, 126, 0.1);
  color: #128C7E;
}

.tracker-period-selector {
  background: rgba(18, 140, 126, 0.1);
  color: #128C7E;
}

.growth-percentage {
  color: #128C7E;
}

.value-bubble {
  background: #128C7E;
}

.chart-point {
  background: #128C7E;
}

.chart-bar {
  background: rgba(18, 140, 126, 0.2);
}

.day-marker.active {
  background: #128C7E;
}

/* Responsive */
@media (max-width: 768px) {
  .income-tracker-card {
    padding: 16px;
  }
  
  .tracker-title-group {
    gap: 8px;
  }
  
  .tracker-icon {
    width: 32px;
    height: 32px;
  }
  
  .tracker-titles h2 {
    font-size: 1.2rem;
  }
  
  .tracker-subtitle {
    font-size: 0.8rem;
    max-width: 200px;
  }
  
  .growth-percentage {
    font-size: 2rem;
  }
  
  .chart-bar-container {
    width: 30px;
  }
  
  .day-marker {
    width: 28px;
    height: 28px;
    font-size: 0.8rem;
  }
}

/* Nouveau style amélioré pour la carte de performance */
.performance-card {
  grid-column: span 1;
  background: white;
  border-radius: 20px;
  padding: 28px;
  display: flex;
  flex-direction: column;
  gap: 24px;
  box-shadow: 0 10px 25px rgba(18, 140, 126, 0.08);
  min-height: 420px;
  background: #f0f0f0;
  border: 1px solid rgba(18, 140, 126, 0.1);
  overflow: hidden;
  position: relative;
}

.performance-card::before {
  content: '';
  position: absolute;
  top: 0;
  right: 0;
  width: 180px;
  height: 180px;
  background: radial-gradient(circle, rgba(18, 140, 126, 0.05) 0%, rgba(255, 255, 255, 0) 70%);
  border-radius: 50%;
  z-index: 0;
}

.performance-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 10px;
  position: relative;
  z-index: 1;
}

.performance-title-container {
  display: flex;
  align-items: center;
  gap: 16px;
}

.performance-icon-wrapper {
  width: 48px;
  height: 48px;
  border-radius: 12px;
  background: rgba(18, 140, 126, 0.1);
  display: flex;
  align-items: center;
  justify-content: center;
  color: #128C7E;
  box-shadow: 0 4px 10px rgba(18, 140, 126, 0.08);
}

.performance-title {
  margin: 0;
  font-size: 1.4rem;
  font-weight: 700;
  color: #1E293B;
  letter-spacing: -0.01em;
}

.performance-description {
  margin: 5px 0 0;
  font-size: 0.85rem;
  color: #64748B;
  max-width: 250px;
}

.filter-dropdown {
  display: flex;
  align-items: center;
  gap: 8px;
  background: rgba(18, 140, 126, 0.08);
  border-radius: 20px;
  padding: 8px 16px;
  font-size: 0.875rem;
  color: #128C7E;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
  box-shadow: 0 2px 5px rgba(18, 140, 126, 0.05);
}

.filter-dropdown:hover {
  background: rgba(18, 140, 126, 0.12);
}

.performance-stats-container {
  display: flex;
  flex-direction: column;
  gap: 20px;
  flex: 1;
  position: relative;
  z-index: 1;
}

.growth-stat {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-top: 5px;
}

.growth-value {
  font-size: 2.2rem;
  font-weight: 800;
  color: #128C7E;
  line-height: 1;
  text-shadow: 0 2px 5px rgba(18, 140, 126, 0.15);
  letter-spacing: -0.03em;
}

.growth-label {
  font-size: 1rem;
  color: #64748B;
  line-height: 1.4;
  max-width: 200px;
}

.highlight-text {
  color: #128C7E;
  font-weight: 600;
}

.performance-chart-container {
  position: relative;
  height: 240px;
  margin-top: 10px;
}

.highlighted-value {
  position: absolute;
  top: -10px;
  left: 50%;
  transform: translateX(-50%);
  text-align: center;
  background: #128C7E;
  color: white;
  padding: 8px 18px;
  border-radius: 30px;
  font-size: 1.2rem;
  font-weight: 700;
  box-shadow: 0 4px 15px rgba(18, 140, 126, 0.2);
  z-index: 10;
  transition: transform 0.3s;
}

.highlighted-value:hover {
  transform: translateX(-50%) translateY(-5px);
}

.value-label {
  font-size: 0.7rem;
  opacity: 0.9;
  font-weight: 400;
  margin-top: 1px;
}

.performance-chart {
  display: flex;
  justify-content: space-around;
  align-items: flex-end;
  height: 100%;
  padding-top: 40px;
}

.chart-column {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 40px;
  position: relative;
  cursor: pointer;
  transition: transform 0.2s;
}

.chart-column:hover {
  transform: translateY(-5px);
}

.chart-dot {
  width: 12px;
  height: 12px;
  border-radius: 50%;
  position: absolute;
  top: 0;
  z-index: 5;
}

.chart-dot.primary {
  background: #128C7E;
  box-shadow: 0 0 0 4px rgba(18, 140, 126, 0.2);
}

.chart-dot.secondary {
  background: #64748B;
  box-shadow: 0 0 0 3px rgba(100, 116, 139, 0.15);
}

.chart-line {
  width: 3px;
  background: #D9E2F5;
  border-radius: 3px;
  transition: height 1s cubic-bezier(0.34, 1.56, 0.64, 1);
}

.chart-column:nth-child(1) .chart-line {
  background: linear-gradient(to top, rgba(18, 140, 126, 0.2), #128C7E);
}

.chart-label {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  background: #F1F5F9;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 600;
  color: #64748B;
  margin-top: 12px;
  font-size: 0.85rem;
  transition: all 0.3s;
  border: 2px solid transparent;
}

.chart-label.active {
  background: #128C7E;
  color: white;
  box-shadow: 0 4px 10px rgba(18, 140, 126, 0.2);
}

.performance-footer {
  display: flex;
  justify-content: center;
  margin-top: auto;
}

.view-details-button {
  display: flex;
  align-items: center;
  gap: 8px;
  background: #128C7E;
  color: white;
  border: none;
  border-radius: 30px;
  padding: 12px 24px;
  font-size: 0.9rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s;
  box-shadow: 0 4px 12px rgba(18, 140, 126, 0.15);
}

.view-details-button:hover {
  background: #0d6e61;
  transform: translateY(-2px);
  box-shadow: 0 6px 15px rgba(18, 140, 126, 0.2);
}

.chatbot-tooltip {
  position: fixed;
  background: white;
  border-radius: 12px;
  padding: 16px;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.1);
  width: 220px;
  pointer-events: none;
  z-index: 1000;
  border: 1px solid rgba(18, 140, 126, 0.1);
  opacity: 0;
  transform: translateY(10px);
  animation: fadeIn 0.3s forwards;
}

@keyframes fadeIn {
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.tooltip-header {
  font-weight: 600;
  font-size: 1rem;
  color: #1E293B;
  margin-bottom: 12px;
  text-align: center;
  border-bottom: 1px solid #f0f0f0;
  padding-bottom: 8px;
}

.tooltip-stats {
  display: flex;
  justify-content: space-between;
}

.tooltip-stat {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
}

.stat-icon {
  font-size: 1.2rem;
}

.stat-value {
  font-weight: 700;
  color: #128C7E;
  font-size: 1rem;
}

.stat-label {
  font-size: 0.7rem;
  color: #64748B;
}

/* Responsive */
@media (max-width: 768px) {
  .performance-card {
    padding: 20px;
  }
  
  .performance-title-container {
    gap: 12px;
  }
  
  .performance-icon-wrapper {
    width: 40px;
    height: 40px;
  }
  
  .performance-title {
    font-size: 1.2rem;
  }
  
  .growth-value {
    font-size: 2.5rem;
  }
  
  .growth-label {
    font-size: 0.85rem;
  }
  
  .chart-column {
    width: 30px;
  }
  
  .chart-label {
    width: 30px;
    height: 30px;
    font-size: 0.75rem;
  }
}
</style> 